export default function TextIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.33325 4.08334C2.33325 3.53974 2.33325 3.26795 2.42206 3.05355C2.54047 2.76768 2.76759 2.54056 3.05345 2.42215C3.26785 2.33334 3.53965 2.33334 4.08325 2.33334H9.91659C10.4602 2.33334 10.732 2.33334 10.9464 2.42215C11.2322 2.54056 11.4594 2.76768 11.5778 3.05355C11.6666 3.26795 11.6666 3.53974 11.6666 4.08334M5.24992 11.6667H8.74992M6.99992 2.33334V11.6667" stroke="#749AC0" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}
